import { IExperience } from 'models/user';
import { diffDates } from 'utils/helpers/dates';

import { getTextUnit } from './formatExperience';

enum DateUnit {
  Year,
  Month,
}

export const getAllExperience = (time: IExperience[]) => {
  let totalYears = 0;
  let totalMonths = 0;

  for (let i = 0; i < time.length; i++) {
    const today = new Date();

    const start = new Date(time[i].start);
    const rawEnd = time[i]?.end; // Для корректной типизации
    const end = rawEnd !== null && rawEnd !== undefined ? new Date(rawEnd) : today;

    // Не добавлять опыт, если сотрудник еще не приступил к работе
    if (start > today) continue;

    const { years, months } = diffDates(start, end);
    totalYears += years;
    totalMonths += months;
  }

  if (totalMonths >= 12) {
    totalYears += Math.floor(totalMonths / 12);
    totalMonths = totalMonths % 12;
  }

  if (totalYears < 1 && totalMonths < 1) {
    return `Меньше 1 месяца`;
  }

  if (totalYears < 1) {
    return `${totalMonths} ${getTextUnit(totalMonths, DateUnit.Month)}`;
  }

  return `${totalYears} ${getTextUnit(totalYears, DateUnit.Year)} ${totalMonths > 0 ? totalMonths : ''} ${getTextUnit(totalMonths, DateUnit.Month)}`;
};
